// extracted by mini-css-extract-plugin
export default {"wrap":"PreviewConsentModal_wrap__9oFjP"};